module.exports = __webpack_public_path__ + "static/img/invite-btn-bg.7e35953.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/ExperienceGold/invite-btn-bg.png
// module id = MjXf
// module chunks = 213